import { render, staticRenderFns } from "./AutocompleteProfessionTask.vue?vue&type=template&id=bfc7af4c"
import script from "./AutocompleteProfessionTask.vue?vue&type=script&lang=js"
export * from "./AutocompleteProfessionTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports